import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFoundSceneProvider from '../scenes/not-found-scene/not-found-scene-provider';
import UploadSceneProvider from '../scenes/upload-scene/upload-scene-provider';
import ThankYouSceneProvider from '../scenes/thank-you-scene/thank-you-scene-provider';
import LoginSceneProvider from '../scenes/login-scene/login-scene-provider';

export type ExtraRouteProps = {
  id: string;
  requiresAuth?: boolean;
  conditional?: (...args: unknown[]) => boolean;
};

export type RouteInfo = {
  path?: string;
  element: React.ReactElement;
  index?: boolean;
} & ExtraRouteProps;

export enum RouteTypes {
  Upload = 'upload',
  ThankYou = 'thank-you',
  Home = 'home',
  Login = 'login',
  NotFound = 'not-found',
}

const Routes: Record<RouteTypes, RouteInfo> = {
  [RouteTypes.Upload]: {
    element: <UploadSceneProvider />,
    id: 'upload-route',
    path: '/upload/',
    requiresAuth: true,
  },
  [RouteTypes.ThankYou]: {
    element: <ThankYouSceneProvider />,
    id: 'thank-you-scene-route',
    path: '/thank-you/',
  },
  [RouteTypes.Login]: {
    element: <LoginSceneProvider />,
    id: 'login-scene-route',
    path: '/login/',
  },
  [RouteTypes.Home]: {
    element: <Navigate
      to={'/login'}
      replace
    />,
    id: 'index-route',
    path: '/',
  },
  [RouteTypes.NotFound]: {
    element: <NotFoundSceneProvider />,
    id: 'not-found-route',
    path: '*', // catch-all route for 404s
  },
};

export default Routes;
